module.exports = __webpack_public_path__ + "static/img/6.eb18c02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/6.png
// module id = iVfM
// module chunks = 0